import { StopTimerData, TimerData, TimeTrackerState } from "../../../models/TimeTracking"
import { SuccessFetchingAction } from "../../../utils/request-actions-helpers/createRequestActions"
import { getCurrentTimeActionTypes, startTimeActionTypes, stopTimeActionTypes, editTimeActionTypes, SET_ACTIVE_TASK_ID, SET_CURRENT_TIME, SET_TIME_TRACKING_TASK, ACTIVATE_TIMER, DISABLED_TIMER, SetActiveTaskIdAction, SetCurrentTimeAction, TimeTrackingTaskAction} from "./actions/timeTrackingActions"

export interface ActionState {
  result: TimeTrackerState
}

export const initialTimeTrackingState: TimeTrackerState = {
    currentTimerData: null,
    startTimerData: null,
    stopTimerData: null,
    editTimerData: null,
    timerTrackingTask: null,
    currentTime: null,
    isTimerOn: false
}
type TimeTrackerReducerActions = SuccessFetchingAction<TimeTrackerState> 

export const timeTrackingReducer = (state: TimeTrackerState = initialTimeTrackingState, action: TimeTrackerReducerActions): TimeTrackerState => {
    switch (action.type) {
        case getCurrentTimeActionTypes.success: {
            const timerAction = action.result as TimerData
            return {
                    ...state,
                    currentTimerData: timerAction,
            }
        }
        case stopTimeActionTypes.success: {
            const timerAction = action.result as StopTimerData
            return {
                    ...state,
                    stopTimerData: timerAction,
            }
        }
        case startTimeActionTypes.success: {
            const timerAction = action.result as TimerData
            return {
                    ...state,
                    startTimerData: timerAction,
            }
        }
        case editTimeActionTypes.success: {
            const timerAction = action.result as TimerData
            return {
                    ...state,
                    editTimerData: timerAction,
            }
        }
        case  SET_TIME_TRACKING_TASK: {
            const timerAction = action as TimeTrackingTaskAction
            return {
                    ...state,
                    timerTrackingTask: timerAction.payload,
                }
            }
        case  SET_CURRENT_TIME: {
            const timerAction = action as SetCurrentTimeAction
            return {
                    ...state,
                    currentTime: timerAction.payload,
                }
            }
        case SET_ACTIVE_TASK_ID: {
            const timerAction = action  as SetActiveTaskIdAction
            return {
                ...state,
                id: timerAction.payload
            }
        }
        case  ACTIVATE_TIMER: 
            return {
                ...state, 
                isTimerOn: true,
            }
        case  DISABLED_TIMER: 
            return {
                ...state, 
                isTimerOn: false,
            }
        default:
            return state
    }
}